export const ADD_ADMIN = 'ADD_ADMIN';
export const EDIT_ADMIN = 'EDIT_ADMIN';
export const GET_ADMINS = 'GET_ADMINS';
export const GET_UNIQUE_ADMIN = 'GET_UNIQUE_ADMIN';
export const DELETE_ADMIN = 'DELETE_ADMIN';
export const GET_LOGGED_ADMIN = 'GET_LOGGED_ADMIN';